export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12896.53e9def4.jpg";